import React, { createContext, useEffect, useState } from 'react';
import { useAppDispatch } from 'src/hooks/store';
import { setIsMobile } from 'src/redux/actions/widgetActions';
var Context = createContext(window.innerWidth < 768);
export var AppProvider = function (_a) {
    var children = _a.children;
    var _b = useState(window.innerWidth < 768), state = _b[0], updateState = _b[1];
    var dispatch = useAppDispatch();
    useEffect(function () {
        var mounted = true;
        var mql = window.matchMedia('(max-width: 767px)');
        var onChange = function () {
            if (!mounted) {
                return;
            }
            dispatch(setIsMobile(mql.matches));
            updateState(mql.matches);
        };
        mql.addEventListener('change', onChange);
        updateState(mql.matches);
        dispatch(setIsMobile(mql.matches));
        return function () {
            mounted = false;
            mql.removeEventListener('change', onChange);
        };
    }, [dispatch]);
    return React.createElement(Context.Provider, { value: state }, children);
};
export var useIsMobile = function () {
    return React.useContext(Context);
};
